import { colors } from "src/styles";
import styled from "styled-components";

export const StyledSpan = styled.span`
  color: ${colors.kleenway.error};
`;
